export const QUERY_KEYS = {
  GLOBAL: {
    FETCH_ENUM: "GLOBAL_FETCH_ENUM",
    MASTER_REGION: "MASTER_REGION",
    MASTER_NATIONALITY: "MASTER_NATIONALITY",
    MASTER_LIVING_RELATIONSHIP: "MASTER_LIVING_RELATIONSHIP",
    MASTER_MAIN_OCCUPATION: "MASTER_MAIN_OCCUPATION",
    MASTER_MAIN_INDUSTRY: "MASTER_MAIN_INDUSTRY",
    MASTER_LOCAL_GOVERNMENT_COUNTER: "MASTER_LOCAL_GOVERNMENT_COUNTER",
    MASTER_LANGUAGE_TEST: "MASTER_LANGUAGE_TEST",
    MASTER_SUPPORT_LANGUAGE: "MASTER_SUPPORT_LANGUAGE",
    MASTER_SKILL_TEST: "MASTER_SKILL_TEST",
    MASTER_SPECIFIC_INDUSTRY: "MASTER_SPECIFIC_INDUSTRY",
    MASTER_SPECIFIC_SKILL_CERTIFICATE: "MASTER_SPECIFIC_SKILL_CERTIFICATE",
    MASTER_MAJOR: "MASTER_MAJOR",
    MASTER_COMPANY_SPECIFIC_INDUSTRY: "MASTER_COMPANY_SPECIFIC_INDUSTRY",
    MASTER_RESIDENCE_STATUS: "MASTER_RESIDENCE_STATUS",
    MASTER_BUSINESS_CLASSIFICATION: "MASTER_BUSINESS_CLASSIFICATION",
    FETCH_MAINTENANCE: "GLOBAL_FETCH_MAINTENANCE",
    PROVINCES_MUNICIPALITIES: "PROVINCES_MUNICIPALITIES",
    MASTER_ATTACHMENT_DOCUMENT_TYPE: "MASTER_ATTACHMENT_DOCUMENT_TYPE",
  },
  MATCH: {
    FETCH_DETAIL: "MATCH_FETCH_DETAIL",
    FETCH_USER_LIST: "MATCH_FETCH_USER_LIST",
    FETCH_USER_LIST_PERSON_IN_CHARGE: "MATCH_FETCH_USER_LIST_PERSON_IN_CHARGE",
    FETCH_USER_DETAIL: "MATCH_FETCH_USER_DETAIL",
    FETCH_BRANCH_LIST: "MATCH_FETCH_BRANCH_LIST",
    FETCH_SUPPORTER_LIST: "FETCH_SUPPORTER_LIST",
    FETCH_BRANCH_DETAIL: "MATCH_FETCH_BRANCH_DETAIL",
    FETCH_SUPPORTER_DETAIL: "MATCH_FETCH_SUPPORTER_DETAIL",
    FETCH_ACCOUNT_DETAIL: "MATCH_FETCH_ACCOUNT_DETAIL",
  },
  PARTNER: {
    FETCH_LIST: "PARTNER_FETCH_LIST",
    FETCH_DETAIL: "PARTNER_FETCH_DETAIL",
  },
  TALENT_FILTER: {
    FETCH_DETAIL: "TALENT_FILTER_FETCH_DETAIL",
    FETCH_LIST: "TALENT_FILTER_FETCH_LIST",
  },
  COMPANY_FILTER: {
    FETCH_DETAIL: "COMPANY_FILTER_FETCH_DETAIL",
    FETCH_LIST: "COMPANY_FILTER_FETCH_LIST",
  },
  CONDITION_AND_SUPPORT_PLAN_COMPANY_FILTER: {
    FETCH_DETAIL: "CONDITION_AND_SUPPORT_PLAN_COMPANY_FILTER_FETCH_DETAIL",
    FETCH_LIST: "CONDITION_AND_SUPPORT_PLAN_COMPANY_FILTER_FETCH_LIST",
  },
  CONDITION_AND_SUPPORT_PLAN_CONDITION_FILTER: {
    FETCH_DETAIL: "CONDITION_AND_SUPPORT_PLAN_CONDITION_FILTER_FETCH_DETAIL",
    FETCH_LIST: "CONDITION_AND_SUPPORT_PLAN_CONDITION_FILTER_FETCH_LIST",
  },
  COMPANY: {
    FETCH_LIST: "COMPANY_FETCH_LIST",
    FETCH_SUPPORTER_LIST: "COMPANY_FETCH_SUPPORTER_LIST",
    FETCH_DETAIL: "COMPANY_FETCH_DETAIL",
    FETCH_USER_LIST: "COMPANY_FETCH_USER_LIST",
    FETCH_USER_DETAIL: "COMPANY_FETCH_USER_DETAIL",
    FETCH_BRANCH_LIST: "COMPANY_FETCH_BRANCH_LIST",
    FETCH_BRANCH_DETAIL: "COMPANY_FETCH_BRANCH_DETAIL",
    FETCH_ACCOUNT_DETAIL: "COMPANY_FETCH_ACCOUNT_DETAIL",
  },
  ADMIN_USER: {
    FETCH_LIST: "ADMIN_USER_FETCH_LIST",
  },
  COMPANY_NAME: {
    FETCH_LIST_BY_EMAIL: "COMPANY_NAME_FETCH_LIST_BY_EMAIL",
  },
  FILE: {
    FETCH_DETAIL: "FILE_FETCH_DETAIL",
    FETCH_INFO: "FILE_FETCH_INFO",
    FETCH_SIGNED_URL: "FILE_FETCH_SIGNED_URL",
    FETCH_COMPANY_SIGNED_URL: "FETCH_COMPANY_SIGNED_URL",
  },
  TALENT: {
    FETCH_LIST: "TALENT_FETCH_LIST",
    FETCH_TALENT_COUNT_BY_STATUS: "TALENT_FETCH_TALENT_COUNT_BY_STATUS",
    FETCH_DETAIL: "TALENT_FETCh_DETAIL",
    FETCH_FILTER_OPTIONS: "TALENT_FETCH_FILTER_OPTIONS",
    FETCH_LEDGER_LIST: "TALENT_FETCH_LEDGER_LIST",
  },
  TALENT_COMMENT: {
    FETCH_LIST: "TALENT_COMMENT_FETCH_LIST",
  },
  TALENT_RETIREMENT: {
    FETCH_LIST: "TALENT_RETIREMENT_FETCH_LIST",
  },
  JOB: {
    FETCH_LIST: "JOB_FETCH_LIST",
    FETCH_DETAIL: "JOB_FETCH_DETAIL",
    FETCH_FILTER_OPTIONS: "JOB_FETCH_FILTER_OPTIONS",
    FETCH_LEDGER_LIST: "JOB_FETCH_LEDGER_LIST",
    FETCH_TAGS: "JOB_FETCH_TAGS",
  },
  FEE: {
    FETCH_LEDGER_LIST: "FEE_FETCH_LEDGER_LIST",
    FETCH_PAYER_OPTIONS: "FEE_FETCH_PAYER_OPTIONS",
  },
  CASE: {
    FETCH_LIST: "CASE_FETCH_LIST",
    FETCH_DETAIL: "CASE_FETCH_DETAIL",
    FETCH_CASE_MATCHES: "CASE_FETCH_CASE_MATCHES",
    FETCH_COUNT: "CASE_FETCH_COUNT",
    FETCH_CASE_SCHEDULES: "CASE_FETCH_CASE_SCHEDULES",
    FETCH_CASE_SCHEDULE_DETAIL: "CASE_FETCH_CASE_SCHEDULE_DETAIL",
    FETCH_FILTER_OPTIONS: "CASE_FETCH_FILTER_OPTIONS",
  },
  CASE_COMMENT: {
    FETCH_LIST: "CASE_COMMENT_FETCH_LIST",
  },
  REGULAR_DOCUMENTS: {
    FETCH_PREVIOUS: "REGULAR_DOCUMENTS_FETCH_PREVIOUS",
    FETCH_PRESENT: "REGULAR_DOCUMENTS_FETCH_PRESENT",
    FETCH_ACCEPTANCE_ACTIVITY_DOCUMENT: "REGULAR_DOCUMENTS_FETCH_ACCEPTANCE_ACTIVITY_DOCUMENT",
    FETCH_ACCEPTANCE_ACTIVITY_FILE: "REGULAR_DOCUMENTS_FETCH_ACCEPTANCE_ACTIVITY_FILE",
    FETCH_TALENT_PAYROLL_LIST: "REGULAR_DOCUMENTS_FETCH_TALENT_PAYROLL_LIST",
    FETCH_TALENT_PAYROLL_FILE_LIST: "REGULAR_DOCUMENTS_FETCH_TALENT_PAYROLL_FILE_LIST",
    FETCH_LIFE_SUPPORT_DOCUMENT: "FETCH_LIFE_SUPPORT_DOCUMENT",
    FETCH_HISTORY_DETAIL: "REGULAR_DOCUMENTS_FETCH_HISTORY_DETAIL",
  },
  RENEW_VISA_DOCUMENTS: {
    FETCH_HISTORY_FOR_TALENT_AND_COMPANY_APPLICATION: "FETCH_HISTORY_FOR_TALENT_AND_COMPANY_APPLICATION",
    FETCH_LIST: "RENEW_VISA_DOCUMENTS_FETCH_LIST",
    FETCH_HISTORY_GROUP_LIST: "RENEW_VISA_DOCUMENTS_FETCH_HISTORY_GROUP_LIST",
    FETCH_GROUP_DETAIL: "RENEW_VISA_DOCUMENTS_FETCH_GROUP_DETAIL",
    FETCH_DETAIL: "RENEW_VISA_DOCUMENTS_FETCH_DETAIL",
    FETCH_DOCUMENT_CREATION_GROUP: "RENEW_VISA_DOCUMENTS_FETCH_DOCUMENT_CREATION_GROUP",
    FETCH_LATEST_DETAIL: "RENEW_VISA_DOCUMENTS_FETCH_LATEST_DETAIL",
    FETCH_TALENT_APPLICATION: "RENEW_VISA_DOCUMENTS_FETCH_TALENT_APPLICATION",
    FETCH_COMPANY_APPLICATION: "RENEW_VISA_DOCUMENTS_FETCH_COMPANY_APPLICATION",
    FETCH_BASIC_INFORMATION_GROUP: "RENEW_VISA_DOCUMENTS_FETCH_BASIC_INFORMATION_GROUP",
    FETCH_UPLOAD_FILE: "RENEW_VISA_DOCUMENTS_FETCH_UPLOAD_FILE",
    FETCH_UPLOAD_AVATAR_FILE: "RENEW_VISA_DOCUMENTS_FETCH_UPLOAD_AVATAR_FILE",
    FETCH_APPLICATION_INFORMATION_GROUP: "RENEW_VISA_DOCUMENTS_FETCH_APPLICATION_INFORMATION_GROUP",
    FETCH_APPLICATION_RESULT_INFORMATION_GROUP: "RENEW_VISA_DOCUMENTS_FETCH_APPLICATION_RESULT_INFORMATION_GROUP",
    FETCH_RESIDENCE_CARD_INFORMATION_GROUP: "RENEW_VISA_DOCUMENTS_FETCH_RESIDENCE_CARD_INFORMATION_GROUP",
  },
  COE_DOCUMENTS: {
    FETCH_LIST: "COE_DOCUMENTS_FETCH_LIST",
    FETCH_TALENT_LIST_FOR_COE: "COE_DOCUMENTS_FETCH_TALENT_LIST_FOR_COE",
    FETCH_REQUEST_ONLINE_UPLOAD_APPLICATION: "COE_DOCUMENTS_FETCH_REQUEST_ONLINE_UPLOAD_APPLICATION",
    FETCH_UPLOAD_FILE_NOTIFICATION: "COE_DOCUMENTS_FETCH_UPLOAD_FILE_NOTIFICATION",
    FETCH_HISTORY_GROUP_LIST: "COE_DOCUMENTS_FETCH_HISTORY_GROUP_LIST",
    FETCH_HISTORY_GROUP_FOR_TALENT_AND_COMPANY_APPLICATION: "FETCH_HISTORY_GROUP_FOR_TALENT_AND_COMPANY_APPLICATION",
    FETCH_GROUP_DETAIL: "COE_DOCUMENTS_FETCH_GROUP_DETAIL",
    FETCH_DETAIL: "COE_DOCUMENTS_FETCH_DETAIL",
    FETCH_DOCUMENT_CREATION_GROUP: "COE_DOCUMENTS_FETCH_DOCUMENT_CREATION_GROUP",
    FETCH_LATEST_DETAIL: "COE_DOCUMENTS_FETCH_LATEST_DETAIL",
    FETCH_TALENT_APPLICATION: "COE_DOCUMENTS_FETCH_TALENT_APPLICATION",
    FETCH_COMPANY_APPLICATION: "COE_DOCUMENTS_FETCH_COMPANY_APPLICATION",
    FETCH_BASIC_INFORMATION_GROUP: "COE_DOCUMENTS_FETCH_BASIC_INFORMATION_GROUP",
    FETCH_UPLOAD_TALENT_FILE: "COE_DOCUMENTS_FETCH_UPLOAD_TALENT_FILE",
    FETCH_UPLOAD_COMPANY_FILE: "COE_DOCUMENTS_FETCH_UPLOAD_COMPANY_FILE",
    FETCH_UPLOAD_AVATAR_FILE: "COE_DOCUMENTS_FETCH_UPLOAD_AVATAR_FILE",
    FETCH_APPLICATION_INFORMATION_GROUP: "COE_DOCUMENTS_FETCH_APPLICATION_INFORMATION_GROUP",
    FETCH_APPLICATION_RESULT_INFORMATION_GROUP: "COE_DOCUMENTS_FETCH_APPLICATION_RESULT_INFORMATION_GROUP",
    FETCH_RESIDENCE_CARD_INFORMATION_GROUP: "COE_DOCUMENTS_FETCH_RESIDENCE_CARD_INFORMATION_GROUP",
  },
  CONDITION_AND_SUPPORT_PLAN_DOCUMENTS: {
    FETCH_COMPANY_LIST: "CONDITION_AND_SUPPORT_PLAN_DOCUMENTS_FETCH_COMPANY_LIST",
    FETCH_CONDITION_DOCUMENT_LIST: "CONDITION_AND_SUPPORT_PLAN_DOCUMENTS_FETCH_CONDITION_DOCUMENT_LIST",
    FETCH_HISTORY_CONDITION_DOCUMENT_LIST: "CONDITION_AND_SUPPORT_PLAN_DOCUMENTS_FETCH_HISTORY_CONDITION_DOCUMENT_LIST",
    FETCH_CONDITION_CONTRACT_DOCUMENT: "CONDITION_AND_SUPPORT_PLAN_DOCUMENTS_FETCH_CONDITION_CONTRACT_DOCUMENT",
    FETCH_CONDITION_WAGE_DOCUMENT: "CONDITION_AND_SUPPORT_PLAN_DOCUMENTS_FETCH_CONDITION_WAGE_DOCUMENT",
  },
  USER: {
    FETCH_ME: "USER_FETCH_ME",
  },
  INFORMATION: {
    FETCH_LIST: "INFORMATION_FETCH_LIST",
    FETCH_DETAIL: "INFORMATION_FETCH_DETAIL",
    CHECK_UNREAD: "INFORMATION_CHECK_UNREAD",
  },
  ANYTIME_DOCUMENTS: {
    FETCH_LIST: "ANYTIME_DOCUMENTS_FETCH_LIST",
    FETCH_DOCUMENT: "ANYTIME_DOCUMENTS_FETCH_DOCUMENT",
    FETCH_TALENT_CONTRACT: "ANYTIME_DOCUMENTS_FETCH_TALENT_CONTRACT",
    FETCH_SUPPORT_CONTRACT: "ANYTIME_DOCUMENTS_FETCH_SUPPORT_CONTRACT",
    FETCH_SUPPORT_PLAN: "ANYTIME_DOCUMENTS_FETCH_SUPPORT_PLAN",
    FETCH_FILE_LIST: "ANYTIME_DOCUMENTS_FETCH_FILE_LIST",
  },
  CONTACT_TYPE: {
    FETCH_LIST: "CONTACT_TYPE_FETCH_LIST",
  },
  CONVERSATION: {
    FETCH_LIST: "CONVERSATION_FETCH_LIST",
    FETCH_DETAIL: "CONVERSATION_FETCH_DETAIL",
    FETCH_MESSAGE_LIST: "CONVERSATION_FETCH_MESSAGE_LIST",
  },
  RETIREMENT_DOCUMENTS: {
    FETCH_LIST: "RETIREMENT_DOCUMENT_FETCH_LIST",
    FETCH_DOCUMENT: "RETIREMENT_DOCUMENT_FETCH_DOCUMENT",
    FETCH_ACCEPTING_WORKER: "RETIREMENT_DOCUMENTS_FETCH_ACCEPTING_WORKER",
    FETCH_TALENT_CONTRACT: "RETIREMENT_DOCUMENTS_FETCH_TALENT_CONTRACT",
    FETCH_FILE_LIST: "RETIREMENT_DOCUMENTS_FETCH_FILE_LIST",
  },
  USER_SETTING: {
    FETCH_DETAIL: "USER_SETTING_FETCH_DETAIL",
  },
  SUPPLIER: {
    FETCH_LIST: "SUPPLIER_FETCH_LIST",
    FETCH_DETAIL: "SUPPLIER_FETCH_DETAIL",
  },
  DASHBOARD: {
    FETCH_COUNT_SUMMARY: "DASHBOARD_FETCH_COUNT_SUMMARY",
    FETCH_MONTHLY_TARGET: "DASHBOARD_FETCH_MONTHLY_TARGET",
    FETCH_COUNT_CASE_MATCHES_SUMMARY: "FETCH_COUNT_CASE_MATCHES_SUMMARY",
    FETCH_RECENT_OFFER_ACCEPTED: "DASHBOARD_FETCH_RECENT_OFFER_ACCEPTED",
    FETCH_RECENT_OFFER_ACCEPTED_PAGINATED: "DASHBOARD_FETCH_RECENT_OFFER_ACCEPTED_PAGINATED",
    FETCH_PERFORMANCE_DETAIL_SUMMARY: "DASHBOARD_FETCH_PERFORMANCE_DETAIL_SUMMARY",
    FETCH_PERFORMANCE_DETAIL_MATCHING: "DASHBOARD_FETCH_PERFORMANCE_DETAIL_MATCHING",
    FETCH_PERFORMANCE_DETAIL_STAFF: "DASHBOARD_FETCH_PERFORMANCE_DETAIL_STAFF",
    FETCH_PERFORMANCE_DETAIL_INDUSTRY: "DASHBOARD_FETCH_PERFORMANCE_DETAIL_INDUSTRY",
    FETCH_PERFORMANCE_DETAIL_PARTNER: "DASHBOARD_FETCH_PERFORMANCE_DETAIL_PARTNER",
    FETCH_PERFORMANCE_DETAIL_CLIENT_TYPE_OFFER: "DASHBOARD_FETCH_PERFORMANCE_DETAIL_CLIENT_TYPE_OFFER",
    FETCH_PERFORMANCE_DETAIL_CLIENT_TYPE_NEW_JOB: "DASHBOARD_FETCH_PERFORMANCE_DETAIL_CLIENT_TYPE_NEW_JOB",
    FETCH_PERFORMANCE_DETAIL_CLIENT_TYPE: "DASHBOARD_FETCH_PERFORMANCE_DETAIL_CLIENT_TYPE",
    FETCH_MATCHING_RESULTS_PAGINATED: "DASHBOARD_FETCH_MATCHING_RESULTS_PAGINATED",
  },
  RECRUITMENT_SOURCE: {
    FETCH_LIST: "RECRUITMENT_SOURCE_FETCH_LIST",
  },
  SAVED_CONDITION: {
    FETCH_LIST: "SAVED_CONDITION_FETCH_LIST",
  },
  SHARING: {
    FETCH_INFO: "SHARING_FETCH_INFO",
    FETCH_DETAIL: "SHARING_FETCH_DETAIL",
    FETCH_TALENT: "SHARING_FETCH_TALENT",
    FETCH_CASE_MATCHES: "SHARING_FETCH_CASE_MATCHES",
    FETCH_SIGNED_URL: "SHARING_FETCH_SIGNED_URL",
  },
} as const;
